window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('select[data-controls]').length) {
    import('./_form-field-toggle.js').then((module) => {
      module.Init();
    });
  }
});

export default {};
